import React from 'react';
import { IAuditoriaCaixaResultado } from '../interfaces/IAuditoriaCaixa';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaCaixaResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Caixa, Espécie e Benefício Indireto não é um tributo — é uma auditoria
// complementar que reúne três análises (Saldo Credor/Omissão de Receita, Operações em Espécie/
// DME e Benefício Indireto). Segue o mesmo padrão de seção própria já usado para Saldos
// Bancários e Depreciação, renderizada abaixo deles no AuditoriaPage.
const AuditoriaResumoCaixa: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias =
    (resultado.saldoCredor?.length || 0) +
    (resultado.operacoesEspecie?.length || 0) +
    (resultado.beneficioIndireto?.length || 0);

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Caixa, Espécie e Benefício Indireto</h3>
      <p className='text-muted'>
        Auditoria complementar — saldo credor de Caixa (presunção de omissão de receita), operações em espécie (DME) e
        pagamentos sem identificação de beneficiário (Benefício Indireto). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro me-1' style={{ fontSize: '0.65rem' }}>ERRO</span>
                <span className='text-muted' style={{ fontSize: '0.75rem' }}>confirmado</span>
              </th>
              <th className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso me-1' style={{ fontSize: '0.65rem' }}>AVISO</span>
                <span className='text-muted' style={{ fontSize: '0.75rem' }}>atenção</span>
              </th>
              <th className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta me-1' style={{ fontSize: '0.65rem' }}>ALERTA</span>
                <span className='text-muted' style={{ fontSize: '0.75rem' }}>suspeita</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_CAIXA')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Caixa, Espécie e Benefício Indireto</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} ocorrência{totalOcorrencias === 1 ? '' : 's'} identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>
                  Saldo Credor + Espécie/DME + Benef. Indireto. Detalhamento por análise disponível na visão expandida.
                </div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
                <div className='text-muted' style={{ fontSize: '0.7rem', marginTop: '2px' }}>ocorrências</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
                <div className='text-muted' style={{ fontSize: '0.7rem', marginTop: '2px' }}>ocorrências</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
                <div className='text-muted' style={{ fontSize: '0.7rem', marginTop: '2px' }}>ocorrências</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoCaixa;
